// removed by extract-text-webpack-plugin
module.exports = {"container":"InfoCarouselItem__container__2DRM6","downloadButtonWrapper":"InfoCarouselItem__downloadButtonWrapper__2Pm5l","mobileDownloadButtonWrapper":"InfoCarouselItem__mobileDownloadButtonWrapper__1X-xM","mobileDownloadButton":"InfoCarouselItem__mobileDownloadButton__1mjSv","position":"InfoCarouselItem__position__1FyHZ","text":"InfoCarouselItem__text__2_dmv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/IndexPage/InfoCarouselItem.scss
// module id = 683
// module chunks = 0